import { fontColor } from 'suneditor/src/plugins'

const styles = theme => ({
  header: {
    position: 'relative',
    display: 'flex',
    '&:hover $headerButtons': {
      display: 'flex',
      alignItems: 'center',
    },
    '&:hover $subHeaderButtons': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  buttons: {
    display: 'none',
    float: 'right',
  },
  button: {
    color: '#637381',
    width: '15px',
    height: '15px',
    marginRight: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  addSubHeaderButton: {
    backgroundColor: 'transparent',
    marginLeft: 12,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  addSubHeaderButtonVisible: {
    display: 'none',
  },
  subHeaderDragIcon: {
    //marginTop: 6,
  },
  subHeaderDragIconVisible: {
    display: 'none',
  },
  subHeaderButtons: {
    display: 'none',
  },
  subHeaderButtonsVisible: {
    display: 'none',
  },
  headerButtons: {
    display: 'none',
  },
  headerButtonsVisible: {
    display: 'none',
  },
  flexGrow: {
    flexGrow: 1,
  },
  subHeaderCardType: {
    float: 'right',
    fontSize: '14px',
    fontWeight: 400,
    color: '#637381',
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center',
  },
  subHeaderCardTypeVisible: {
    display: 'none',
  },

  document: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minWidth: '60px',
    backgroundColor: '#F4F6F8',
    padding: '6px',
    borderRadius: '6px',
    opacity: 0.6,
    '&:hover': {
      cursor: 'pointer',
      opacity: 1,
    },
  },
  documentName: {
    fontSize: 12,
    fontWeight: 400,
    color: '#002E47',
  },
})

export default styles
